import React, { useState } from 'react';

const AccordionItem = ({ title, children, className = "" }) => {
  const [isActive, setIsActive] = useState(false);

  const toggleAccordion = () => {
    setIsActive(!isActive);
  };

  return (
    <div className={`accordion-item ${className} ${isActive ? 'active' : ''}`}>
      <button
        className="accordion-title"
        onClick={toggleAccordion}
      >
        {title}
        <span className="accordion-icon">{isActive ? '-' : '+'}</span>
      </button>
      <div className="accordion-content">
        {children}
      </div>
    </div>
  );
};

export default AccordionItem;